import { PhoneMaxWidth, TabletMaxWidth, TinyPhoneMaxWidth } from '@racemap/utilities/consts/common';
import { useMediaQuery } from './useMediaQuery';

/**
 * The device steps. Nothing else in the frontend defines a width. Pick a step by what the layout
 * needs: phone is single column and touch controls, tablet still fits a desktop layout but no
 * sidebar, tinyPhone is where even a phone layout has to drop a label.
 */
export const Breakpoint = {
  tinyPhone: TinyPhoneMaxWidth,
  phone: PhoneMaxWidth,
  tablet: TabletMaxWidth,
} as const;

export type BreakpointStep = keyof typeof Breakpoint;

/** Matches at this step and below. Use in an `@media` block instead of a pixel literal. */
export const upTo = (step: BreakpointStep) => `(max-width: ${Breakpoint[step]}px)`;

/** Matches above this step. The exact complement of {@link upTo}, so the `+ 1` lives here only. */
export const above = (step: BreakpointStep) => `(min-width: ${Breakpoint[step] + 1}px)`;

/** True at phone width: single column, stacked toolbars, touch controls. */
export const useIsPhone = () => useMediaQuery(upTo('phone'));

/** True on the narrowest phones, where even a phone layout has to drop something. */
export const useIsTinyPhone = () => useMediaQuery(upTo('tinyPhone'));

/** True at tablet width and below: a desktop layout still fits, a sidebar or map pane does not. */
export const useIsTabletOrBelow = () => useMediaQuery(upTo('tablet'));
